import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IVehicleParams, IVehicleResponse, IVehicleState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateVehicle = createAsyncThunk(
  'listVehicles/fetchCreateVehicle',
  async (params: IVehicleParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createVehicle(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IVehicleState = {
  isLoading: false,
  response: null,
  error: null
}

const createVehicleSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetCreateVehicle: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateVehicle.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateVehicle.fulfilled, (state, action: PayloadAction<IVehicleResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateVehicle.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createVehicleSlice.reducer
export const { resetCreateVehicle } = createVehicleSlice.actions
